import script from "./SudokuGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./SudokuGrid.vue?vue&type=script&setup=true&lang=js"

import "./SudokuGrid.vue?vue&type=style&index=0&id=44425156&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44425156"]])

export default __exports__